import { APP_BASE_HREF, CommonModule } from '@angular/common';
import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { baseHrefConfig } from 'src/shared/constants/base-href-config/base-href-config';

import type { WrikeDynamicBaseHrefModuleConfiguration } from './types';
import { WrikeDynamicBaseHrefService } from './wrike-dynamic-base-href.service';

export function baseHrefFactory(
    initializer: WrikeDynamicBaseHrefService,
    config: WrikeDynamicBaseHrefModuleConfiguration,
    translateService: TranslateService
) {
    initializer.initialize(config, translateService);
    return initializer.generateBase();
}

@NgModule({
    declarations: [],
    imports: [CommonModule],
})
export class WrikeDynamicBaseHrefModule {
    static forRoot(): ModuleWithProviders<WrikeDynamicBaseHrefModule> {
        return {
            ngModule: WrikeDynamicBaseHrefModule,
            providers: [
                {
                    provide: 'BASE_HREF_CONFIG',
                    useValue: baseHrefConfig,
                },
                WrikeDynamicBaseHrefService,
                {
                    provide: APP_BASE_HREF,
                    useFactory: baseHrefFactory,
                    deps: [WrikeDynamicBaseHrefService, 'BASE_HREF_CONFIG', TranslateService],
                },
            ],
        };
    }
}
